
import React, { useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Login from './Components/Login/Login';
import Register from './Components/Registration/Register'
import MyLearnings from './Components/MyLearnings/MyLearning'
import Home from './Components/Home/Home'
import Syllabus from './Components/Syllabus/Syllabus'
import Lesson from './Components/Lessons/Lesson'
import Layout from './Components/Layout';
import LearningDetail from './Components/LerningDetail/LearningDetail';
import SkillsDetail from './Components/SkillsDetail/SkillsDetail';
import CreateSkill from './Components/CreateSkill/CreateSkill';
import TopicSingle from './Components/TopicSingle/TopicSingle';
import Category from './Components/Category/Category';
import Support from './Components/Support/Support';
import Community from './Components/Community/Community';
import Requests from './Components/Requests/Requests';
import Message from './Components/Message/Message';
import Answer from './Components/AnswerSummary/Answer';
import Calendar from './Components/Calendar/Calendar';
import UserCalendar from './Components/MentorCalendar/Calendar'
import Search from './Components/Search/Search';
import Role from './Components/RoleSelecting/Role';
import Testing from './Components/Invitation/Invite';
import TransactionHistory from './Components/TransactionHistory/TransactionHistory';
import AccountValidation from './Components/AccountValidation/AccountValidation';
import RegistrationSuccess from './Components/RegistrationSuccess/RegistrationSuccess';
import ConnectionProfile from './Components/ConnectionProfile/ConnectionProfile';
import PasswordReset from './Components/PasswordReset/PasswordReset'
import Billing from './Components/Billing/Billing'
import Exams from './Components/Exams/Exams';
import ExamSummary from './Components/ExamSummary/ExamSummary';
import MobileLearning from './Components/MobileLearning/MobileLearning';
import MobileAssessment from './Components/MobileAssessment/MobileAssessment';
import MobileInsights from './Components/MobileInsights/MobileInsights';
import Quiz from './Components/Quiz/Quiz'
import QuizQuestions from './Components/QuizQuestions/QuizQuestions';
import Flip from './Components/Flip/Flip';
import Forum from './Components/Forum/Forum';
import Events from './Components/Events/Events';
import EventDetails from "./Components/EventDetails/EventDetails";

import Subscription from "./Components/Subscription/Subscription";
import SubscriptionSuccess from "./Components/SubscriptionSuccess/Success";
import SubscriptionFail from "./Components/SubscriptionFail/Fail";
import SubscriptionReady from "./Components/Ready/Ready";
import Start from "./Components/Start/Start";
import Layer from "./Layer";
import Dashboard from "./Components/Dashboard/Dashboard"
import Learnings from "./Components/Learnings/Learnings"
import NewLearningDetail from './Components/NewLearningDetail/NewLearningDetail';
import Assessment from './Components/Assessment/Assessment'
import ResetPassword from './Components/ResetPassword/ResetPassword';
import DailyDrill from './Components/DailyDrill/DailyDrill';
import WeeklyWorkout from './Components/WeeklyWorkout/WeeklyWorkout';
import Profile from './Components/NewProfile/Profile';
import ProfileDetails from './Components/NewProfile/ProfileDetails';
import AddSkills from './Components/AddSkills/AddSkills';
import SkillsEdit from './Components/SkillsEdit/SkillsEdit';
import EditSkill from './Components/EditSkill/EditSkill';
import EmailVerification from './Components/EmailVerification/EmailVerification';
import SubscriptionDetails from './Components/SubscriptionDetails/SubscriptionDetails';
import Performance from './Components/Performance/Performance';
import Insights from './Components/Insights/Insights'
import Activity from './Components/Activities/Activity'
import TaskMentorView from './Components/TaskMentorView/TaskMentorView'
import TaskCompletion from './Components/Activities/TaskCompletion'
import Opportunities from './Components/Opportunities/Opportunities'
import Offers from './Components/Offers/Offers'
import JobDetailsView from './Components/JobDetailsview/JobDetailsView'
import ChatPopup from './Components/ChatPopup/ChatPopup';
import PublicProfile from './Components/PublicProfile/PublicProfile';
import SkillsDetails from './Components/SkillsDetails/SkillsDetails';
import PublicEventDetails from './Components/PublicEventDetails/PublicEventDetails';
import PublicOpportunityDetails from './Components/PublicOpportunityDetails/PublicOpportunityDetails';
import { LearningProvider } from './Components/Context/LearningContext';
import MentorLogin from './Components/MentorLogin/MentorLogin'
import MentorSignUp from './Components/MentorSignUp/MentorSignUp'
import { baseurl } from './Components/Url'
import UserLearning from './Components/UserLearning/UserLearning';
import MentorModule from "./Components/MentorModule/MentorModule";
import MentorAssessmentView from "./Components/MentorAssessmentView/MentorAssessmentView";

function App() {
  return (
    <div className="App">

      <Router>
        <Routes>
          {/* Layout routes first so /profile/profile-details matches ProfileDetails, not PublicProfile */}
          <Route element={<LearningProvider><Layout /></LearningProvider>}>
            <Route path='/' element={<Dashboard />} />
            <Route path='/profile' element={<Profile />} />
            <Route path='/profile/profile-details' element={<ProfileDetails />} />
            <Route path='/profile/add-skills' element={<AddSkills />} />
            <Route path='/profile/edit-skills' element={<SkillsEdit />} />
            <Route path='/profile/edit-skill' element={<EditSkill />} />
            <Route path='/learnings' element={<MyLearnings />} />
            <Route path='/syllabus' element={<Syllabus />} />
            <Route path='/lesson' element={<Lesson />} />
            <Route path='/lerning/detail' element={<LearningDetail />} />
            <Route path='/skills/detail' element={<SkillsDetail />} />
            <Route path='/skills/create-skill' element={<CreateSkill />} />
            <Route path='/singletopic' element={<TopicSingle />} />
            <Route path='/skills' element={<Category />} />
            <Route path='/support' element={<Support />} />
            <Route path='/community' element={<Community />} />
            <Route path='/requests' element={<Requests />} />
            <Route path='/message' element={<Message />} />
            <Route path='/answers' element={<Answer />} />
            <Route path='/calendar' element={<Calendar />} />
            <Route path='/usercalendar' element={<UserCalendar />} />
            <Route path='/transactionhistory' element={<TransactionHistory />} />
            <Route path='/peerprofile' element={<ConnectionProfile />} />
            <Route path='/billing' element={<Billing />} />
            <Route path='/exams' element={<Exams />} />
            <Route path='/exam/summary' element={<ExamSummary />} />
            <Route path='/quiz' element={<Quiz />} />
            <Route path='/quiz/questions' element={<QuizQuestions />} />
            <Route path='/forum' element={<Forum />} />
            <Route path='/events' element={<Events />} />
            <Route path='/event/details' element={<EventDetails />} />
            <Route path='/new/learnings' element={<Learnings />} />
            <Route path='/new/learnings/detail' element={<NewLearningDetail />} />
            <Route path='/assessments' element={<Assessment />} />
            <Route path='/daily/drill' element={<DailyDrill />} />
            <Route path='/weekly/workout' element={<WeeklyWorkout />} />
            <Route path="/subscribe/details" element={<SubscriptionDetails />} />
            <Route path="/performance" element={<Performance />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/task-mentor-view" element={<TaskMentorView />} />
            <Route path="/mentor-module" element={<MentorModule />} />
            <Route path="/mentor-assessment-view" element={<MentorAssessmentView />} />
            <Route path="/task/completion" element={<TaskCompletion />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/job-view/:jobId" element={<JobDetailsView />} />
            <Route path="/chat" element={<ChatPopup />} />
            <Route path="/user/learning" element={<UserLearning />} />
          </Route>
          <Route element={<Layer />} >
            <Route path="/login" element={<Login />} />
            <Route path="/patner/login" element={<Login />} />
            <Route path='/login/mentor' element={<MentorLogin />} />
            <Route path="/register" element={<Register />} />
            <Route path="/patner/register" element={<Register />} />
            <Route path="/register/mentor" element={<MentorSignUp />} />
            <Route path="/subscribe" element={<Subscription />} />
            <Route path="/subscribe/success" element={<SubscriptionSuccess />} />
            <Route path="/subscribe/failed" element={<SubscriptionFail />} />
            <Route path="/subscribe/ready" element={<SubscriptionReady />} />
            <Route path="/start" element={<Start />} />
            <Route path="/reset/password" element={<ResetPassword />} />
            <Route path="/email/verification" element={<EmailVerification />} />
          </Route>


          {/* <Route path='/login' element={<Login />} /> */}
          {/* <Route path='/register' element={<Register />} /> */}
          <Route path='/search' element={<Search />} />
          <Route path='/profile/:profileName' element={<PublicProfile />} />
          <Route path='/users/events/:userId/:eventId' element={<PublicEventDetails />} />
          <Route path='/opportunities/details/:userId/:jobId' element={<PublicOpportunityDetails />} />
          <Route path='/skills/details/:learningId/:userId' element={<SkillsDetails />} />
          <Route path='/skills/details/:learningId' element={<SkillsDetails />} />
          <Route path='/roleselection' element={<Role />} />
          <Route path='/invite' element={<Testing />} />
          <Route path='/account/validation' element={<AccountValidation />} />
          <Route path='/registration/success' element={<RegistrationSuccess />} />
          <Route path='/resetpassword' element={<PasswordReset />} />
          {/* <Route path='/mobile/learning/65d44447a7b6b2398a9e1d7f/0202402191217201220135/65d44f4da7b6b2398a9e1d86/true' element={<MobileLearning/>}/> */}
          <Route path='/mobile/learning/:learningId/:currentTopicId/:userId/:adminStatus' element={<MobileLearning />} />
          <Route path='/mobile/assessment/:learningId/:currentTopicId/:userId/:adminStatus/:source' element={<MobileAssessment />} />
          {/* <Route path='/mobile/assessment/65dc5dd9c784d95706d187a8/020240226094214914388/65dc5c0ac784d95706d187a3/true/support' element={<MobileAssessment />} /> */}
          {/* <Route path='/mobile/insights/65d44447a7b6b2398a9e1d7f/0202402191217201220135/65d44f4da7b6b2398a9e1d86/true' element={<MobileInsights />} /> */}
          <Route path='/mobile/insights/:learningId/:currentTopicId/:userId/:adminStatus' element={<MobileInsights />} />
          <Route path='/flip' element={<Flip />} />
          <Route path='duno/events' element={<Events />} />
          <Route path='duno/forum' element={<Forum />} />
        </Routes>
      </Router>

    </div>
  );
}

export default App;
